import { ConversationService } from '@klant/conversational-connector/services/conversation/conversation.service';
import { ConversationalConnectorAnalyticsService } from '@klant/conversational-connector/services/analytics/analytics.service';
import { KlantConversationalConnectorService } from '@klant/conversational-connector/klant-conversational-connector.service';
import { ConversationalChatMapper } from '@klant/conversational-connector/mappers/conversational-chat-mapper/conversational-chat.mapper';
import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';

import { Component, computed, inject, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';
import { FloatingActionButtonModel } from '@ap/floating-action-button';

import { ConversationalChatStore } from '../../../signal-stores/conversational-chat-store/conversational-chat.store';

import content from './conversational-chat-container.content.json';

@Component({
    selector: 'conversational-chat-container',
    templateUrl: './conversational-chat-container.component.html',
    standalone: false
})
export class ConversationalChatContainerComponent implements OnInit {
    public chatVisibility = computed(() => {
        return this.conversationService.getChatVisibility();
    });
    public isChatOpenedOrMinimized = computed(() => {
        return (
            this.chatVisibility() === ConversationalChatVisibility.OPEN || this.chatVisibility() === ConversationalChatVisibility.MINIMIZED
        );
    });
    public isChatOpen = computed(() => {
        return this.chatVisibility() === ConversationalChatVisibility.OPEN;
    });

    private readonly chatStore = inject(ConversationalChatStore);
    private readonly conversationalConnectorAnalyticsService = inject(ConversationalConnectorAnalyticsService);
    private readonly contentService = inject(ApContentService);
    private readonly klantConversationalConnectorService = inject(KlantConversationalConnectorService);
    protected readonly conversationService = inject(ConversationService);

    ngOnInit() {
        this.contentService.addContentItems(content);
    }

    public changeChatVisibility(status: FloatingActionButtonModel): void {
        const conversationVisibility = ConversationalChatMapper.mapFloatingActionButtonModelToConversationalChatVisibility(status);
        if (this.chatStore.idleTimerActive()) {
            this.conversationalConnectorAnalyticsService.clickEvent('Minimize', 'Minimaliseren tijdens inactiviteitsmelding');
        } else {
            this.conversationalConnectorAnalyticsService.clickEvent('Conversational', status);
        }

        this.conversationService.setConversationVisibility(conversationVisibility);
    }
}
